import { Component, OnInit } from '@angular/core';
import { PropertiesService } from '../properties.service';
import { Property } from 'models/property.model';
import { AuthService } from '../shared/services/auth.service';
import { NotificationsService } from '../notifications.service';

@Component({
  selector: 'app-mobile-navbar',
  templateUrl: './mobile-navbar.component.html',
  styleUrls: ['./mobile-navbar.component.scss']
})
export class MobileNavbarComponent implements OnInit {

  constructor(private notifications: NotificationsService, private properties: PropertiesService, private authService: AuthService) { }

  ngOnInit() {
  }

  markNotificationsSeen() {
    this.notifications.markNotificationsSeen(this.authService.userData.uid).then(reply => console.log('notifications seen'));
  }

  setProperty = (property: Property) => {
    this.properties.currentProperty = property;
  }

}
